import z from "zod";
import { definePluginContext } from "@/plugins/server/builder";
import type { Message } from "@/shared/messages";

export const memoriesPluginContextDef = definePluginContext({
  schema: z.object({
    memoriesLastResults: z.custom<Map<string, Message[]>>().prefault(new Map()),
    memoriesLastTimestamp: z.custom<Map<string, number>>().prefault(new Map()),
    processedRequestsIds: z.custom<Set<string>>().prefault(new Set<string>()),
    computedMemoriesCache: z
      .custom<Map<string, { hash: string; memories: Message[] }>>()
      .prefault(new Map()),
  }),
});
